import { useNextRouterContext } from "@faire/retailer-visitor-shared/app/_lib/routing/NextRouterContext";
import { setTimeoutIfPossible } from "@faire/retailer-visitor-shared/lib/async-functions/setTimeoutIfPossible";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSettingNextJSRscCategoryPage } from "@faire/retailer-visitor-shared/settings/useSettingNextJSRscCategoryPage";
import { PrefetchKind } from "next/dist/client/components/router-reducer/router-reducer-types";
import React from "react";

const PREFETCH_DELAY_MS = 250;

export const useCategoryNavigationPrefetch = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const { prefetch: nextPrefetch } = useNextRouterContext();
  const isRSCCategoryPageEnabled = useSettingNextJSRscCategoryPage();
  const shouldEnableNextJSPrefetch =
    isLoggedInRetailer && isRSCCategoryPageEnabled;
  const timeoutRef = React.useRef<NodeJS.Timeout | undefined>(undefined);

  const onMouseEnter = React.useCallback(
    (url?: string) => {
      if (shouldEnableNextJSPrefetch) {
        timeoutRef.current = setTimeoutIfPossible(() => {
          if (url) {
            nextPrefetch(url, { kind: PrefetchKind.FULL });
          }
        }, PREFETCH_DELAY_MS);
      }
    },
    [nextPrefetch, shouldEnableNextJSPrefetch]
  );

  const onTouchStart = React.useCallback(
    (url?: string) => {
      if (shouldEnableNextJSPrefetch && url) {
        nextPrefetch(url, { kind: PrefetchKind.FULL });
      }
    },
    [nextPrefetch, shouldEnableNextJSPrefetch]
  );

  const onBlur = React.useCallback(() => {
    if (shouldEnableNextJSPrefetch) {
      clearTimeout(timeoutRef.current);
    }
  }, [shouldEnableNextJSPrefetch]);

  return {
    prefetchOnMouseEnter: onMouseEnter,
    prefetchOnTouchStart: onTouchStart,
    clearPrefetchTimeoutOnBlur: onBlur,
  };
};

// check if current url start with /category
export const isCategoryUrl = (url: string) => /^\/category\//.test(url);
